import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa'; // Using a chevron icon for the dropdown arrow

const CustomDropdown = ({ options, value, onChange, placeholder, buttonClass, menuClass, optionClass }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleOptionClick = (optionValue) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    const displayValue = options.find(option => option.value === value)?.label || placeholder;

    return (
        <div className="relative font-[Archivo] inline-block" ref={dropdownRef}>
            {/* Dropdown Button */}
            <button
                type="button"
                className={`flex items-center justify-between min-w-[100px] px-3 py-2 text-sm font-semibold rounded-lg border border-gray-300 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#2573EB] focus:ring-opacity-50 transition-colors ${buttonClass}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {displayValue}
                <FaChevronDown className={`ml-2 h-3 w-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div
                    className={`absolute z-[100] mt-2 w-full max-h-60 overflow-y-auto bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 ${menuClass}`}
                    style={{ minWidth: dropdownRef.current ? dropdownRef.current.offsetWidth : 'auto' }}
                >
                    <div>
                        {options.map((option) => (
                            <div
                                key={option.value}
                                onClick={() => handleOptionClick(option.value)}
                                className={`
            flex items-center px-4 py-2 text-sm text-gray-700 cursor-pointer
            hover:bg-[#2573EB] hover:text-white
            ${optionClass}
          `}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                </div>
            )}

        </div>
    );
};

export default CustomDropdown;